import { useEffect, useState } from 'react';
import { getEnv } from '../utils/env-helper';

/**
 * This component doesn't render anything visible, but initializes
 * subscription-related environment variables for the client side.
 * It ensures that all required Stripe variables are properly loaded.
 */
const SubscriptionEnvironmentInitializer = () => {
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined' && !initialized) {
      // Log all available NEXT_PUBLIC_STRIPE variables
      const stripeVars = {};

      // Product prefixes
      const productPrefixes = ['VMC', 'GMC', 'CMC', 'MRM'];

      // Subscription periods
      const periods = [1, 2, 3];

      // Collect all subscription variables
      productPrefixes.forEach((prefix) => {
        periods.forEach((period) => {
          const priceKey = `STRIPE_${prefix}_${period}_YEAR_PRICE`;
          const productKey = `STRIPE_${prefix}_${period}_YEAR_PRODUCT`;

          // getEnv() will automatically add NEXT_PUBLIC_ prefix
          const priceValue = getEnv(priceKey);
          const productValue = getEnv(productKey);

          // Store the values with full key name for reference
          stripeVars[`NEXT_PUBLIC_${priceKey}`] = priceValue;
          stripeVars[`NEXT_PUBLIC_${productKey}`] = productValue;
        });
      });

      setInitialized(true);
    }
  }, [initialized]);

  // This component doesn't render anything visible
  return null;
};

export default SubscriptionEnvironmentInitializer;
